import React, {Fragment} from 'react';
import createEditor from '../form/ComponentEditor';
import Box from '../layout/Box';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import businesstransactionForm from "./forms/businesstransactionForm";
import businesstransactionList from "./lists/businesstransactionList";

class businesstransactionEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        const BusinesstransactionForm = businesstransactionForm;
        const BusinesstransactionList = businesstransactionList;
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        return (
            <Fragment>
                <List
                    {...this.props}
                    theme="default"
                    header={"Tranzakciók"}
                >
                    <BusinesstransactionList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header={"Tranzakciós adatok"}
                >
                    <BusinesstransactionForm {...this.props} />
                </Editor>
            </Fragment>
        );
    }
}

export default createEditor({componentName: "businesstransaction", WrappedComponent: businesstransactionEditor});
